import React from 'react';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { rows } from '../../data/transformation';
export function Transformation() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-240" data-mp="1nopn93i0bj2e">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-241" data-mp="1nrlmcv5lcdsf">
        <SectionTag icon="✨" tone="primary" data-id="element-242" data-mp="1irprblevfwp0">
          La transformación
        </SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold leading-tight text-primary sm:text-4xl" data-id="element-243" data-mp="2ffm2ubvgc1td">
          De una profesora improvisando a una guía experta.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-ink sm:text-lg" data-id="element-244" data-mp="26ntse16fgsos">
          8.200+ horas ahorradas al año en planificación.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-3xl px-4 sm:px-6" data-id="element-245" data-mp="21n64vpheqtzb">
        <ScrollHintTable minWidth="520px" data-id="element-246" data-mp="2z5poiomc188k">
          <table className="w-full text-left text-sm" data-id="element-247" data-mp="2z6qyeprm3oop">
            <thead data-id="element-248" data-mp="2ucwjs0qv5zwh">
              <tr className="border-b border-primary/10 bg-blush/60 text-xs uppercase tracking-wide text-ink" data-id="element-249" data-mp="2ucd4krsllpm5">
                <th className="px-5 py-3 font-semibold" data-id="element-250" data-mp="15a9efdnjh0ui">Antes</th>
                <th className="px-5 py-3 font-semibold" data-id="element-251" data-mp="1a67wykm6ron0">Con Enciclopedia Pilates 360</th>
              </tr>
            </thead>
            <tbody data-id="element-252" data-mp="wfmcwskzx8nj">
              {rows.map((row, i) => <tr key={row.antes} className={i !== rows.length - 1 ? 'border-b border-primary/5' : ''} data-id="element-253" data-mp="10goc59ewxkpi" data-mpi={i}>
                  <td className="bg-blush/20 px-5 py-4 align-top text-ink" data-id="element-254" data-mp="mgnavsuqkb9i">{row.antes}</td>
                  <td className="bg-skyblue/40 px-5 py-4 align-top font-medium text-primary" data-id="element-255" data-mp="rh1k3e82pr94">{row.con}</td>
                </tr>)}
            </tbody>
          </table>
        </ScrollHintTable>
      </div>
    </section>;
}